import React, { useEffect, useState, useRef } from 'react';
import { Box, CircularProgress, IconButton, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import tutorials from '../../data/tutorials.json';
import TutorialsTreeMap from '../submodules/TutorialsTreeMap';
import ReactHTMLParser from 'react-html-parser';
import axios from 'axios'

const Tutorials = (props) => {
  const [activeTutorialURI, setActiveTutorialURI] = useState(tutorials[0]?.uri);
  const [searchQuery, setSearchQuery] = useState('');
  const [isTutorialLoading, setIsTutorialLoading] = useState(true);
  const [activeTutorialHTML, setActiveTutorialHTML] = useState(null);
  const helpURL = 'https://cadsoftcorporation1.mcoutput.com/personalarchhelp/Content/';
  const searchURL = helpURL + 'Search1.htm?q=';
  const renderedHTMLRef = useRef(null);

  useEffect(() => {
    if (activeTutorialURI) {
      setIsTutorialLoading(true);
      axios.get(activeTutorialURI)
        .then(res => res.data)
        .then(data => {
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = data;
          const bodyContainer = tempContainer.querySelector('.body-container');
          if (bodyContainer) {
            const bodyContent = bodyContainer.innerHTML;
            const editedBodyContent = bodyContent.replace(/src="/g, `src="${helpURL}`);
            setActiveTutorialHTML(editedBodyContent);
            setIsTutorialLoading(false);
          }
        })
        .catch(error => { console.error(error) })
        .finally(() => {});
    }
    
    return () => {}
  }, [activeTutorialURI]);

  const handleTutorialLinkClick = (url) => {
    const activeURL = helpURL + url;
    setActiveTutorialURI(activeURL);
  };

  const handleTutorialSearch = () => {
    const searchedURL = searchURL + searchQuery;
    window.location.href = searchedURL;
  };
  
  const modifiedHTML = activeTutorialHTML?.replace(/<a\b[^>]*href=['"](.*?)['"][^>]*>(.*?)<\/a>/g, (match, href, content) => {
    return `<button style="background-color: transparent; border: 1px solid #b71c1c; border-radius: 4px; cursor: pointer;" data-href="${href}">${content}</button>`;
  });

  useEffect(() => {
    if (renderedHTMLRef.current) {
      const buttons = renderedHTMLRef.current.querySelectorAll('button');
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          handleTutorialLinkClick(button.getAttribute('data-href'));
        });
      });
      
      return () => {
        buttons.forEach(button => {
          button.removeEventListener('click', () => {
            handleTutorialLinkClick(button.getAttribute('data-href'));
          });
        });
      };
    }
  }, [activeTutorialHTML]);

  return (
    <Box sx={{display: 'flex', flex: 4, flexWrap: 'wrap', justifyContent: 'center', m: 2}}>
      <Paper sx={{flex: 1, m: 1, minWidth: 350, maxWidth: 400}}>
        <Box sx={{m: 1}}>
          <TextField
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end" onClick={() => handleTutorialSearch()}>
                  <IconButton size="small">
                    <ArrowForwardIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            label="Search"
            onChange={(e) => { setSearchQuery(e.target.value) }}
            onKeyDown={(e) => { if (e.key === 'Enter') handleTutorialSearch() }}
            placeholder="Search..."
            size="small"
            value={searchQuery}
          />
        </Box>
        <Box sx={{maxHeight: '72.5vh', overflowY: 'scroll'}}>
          <TutorialsTreeMap tree={tutorials} setActiveTutorialURI={setActiveTutorialURI} />
        </Box>
      </Paper>
      <Paper sx={{display: 'flex', flex: 3, minWidth: 350, m: 1, p: 2}}>
        <Box sx={{flex: 1, maxHeight: '72.5vh', overflowY: 'scroll'}}>
          {/* Displays activeTutorialURI for debugging. */}
          {/* <Typography>activeTutorialURI: {activeTutorialURI}</Typography> */}
          <Box sx={{display: 'flex', flex: 1}}>
            { isTutorialLoading ? (
              <Box sx={{alignItems: 'center', display: 'flex', flex: 1, justifyContent: 'center'}}>
                <CircularProgress />
              </Box>
            ) : (
              <Box>
                { modifiedHTML ? (
                  <Box className="renderedHTML" ref={renderedHTMLRef}>
                    { ReactHTMLParser(modifiedHTML, {
                        decodeEntities: true,
                        transform: (node, index) => {
                          // Handle any additional transformations if needed
                          return undefined;
                        }
                      })
                    }
                  </Box>
                ) : (
                  <Typography>No tutorial content available.</Typography>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}

export default Tutorials;
